import {
  COMMERCIAL,
  ENGINEERING_NETWORKS,
  FURNISHING_SUPERVISOR,
  HEAD_EN,
  HEAD_OVP,
  IZS,
  MKD,
  OBSERVER,
  PARTNER,
  PLANNER,
  PRIME_CONTRACTOR,
  HOUSING_CONTRACTOR,
  ROUTES,
  SUPERVISOR,
  USK_PRE_ACCEPTANCE,
  ACCOUNTING_TYPES,
} from 'consts';

// Указываем только необходимые роуты
// Порядок имеет значение

// *
// **
// Тут указываются какие элементы отображаем в Layout
// **
// *
const COMMERCIAL_MENU = [
  ROUTES.APARTMENT_STATUS.ROOT,
  ROUTES.PLACEMENTS_STATUS.ROOT,
  ROUTES.TIMESHEET.APARTMENTS,
  ROUTES.CALLS.APARTMENTS,
  ROUTES.CALLS.APARTMENTS_ALLOCATED,
  ROUTES.CALLS.APARTMENTS_UNALLOCATED,
  ROUTES.DEFECTS.APARTMENTS,
  ROUTES.PLAN.ROOT,
  ROUTES.PLAN.PLACEMENTS,
  ROUTES.PLAN.ENGINEERINGS,
  ROUTES.PLAN.NEW_ENGINEERING,
  ROUTES.START_SETTLEMENT.ROOT,
  ROUTES.TIMETABLE.ROOT,
  ROUTES.TIMETABLE.APARTMENTS,
  ROUTES.TIMETABLE.APARTMENTS_MANAGERS,
  ROUTES.TIMETABLE.APARTMENTS_PROJECTS,
  ROUTES.SETTING.APARTMENTS,
  // ROUTES.ANALYTICS.CONTRACTOR,
  ROUTES.ANALYTICS.TRANSFER_TO_SETTLEMENT,
  ROUTES.ANALYTICS.RATING,
  ROUTES.ANALYTICS.REPORTING_OVP,
  ROUTES.ANALYTICS.APARTMENT_STATUS,
  ROUTES.DELIVERY_SCHEDULE.APARTMENTS,
];

const ENGINEERING_NETWORKS_MENU = [
  ROUTES.PLACEMENTS_STATUS.ROOT,
  ROUTES.CALLS.ENG_NETWORKS,
  ROUTES.CALLS.ENG_NETWORKS_ALLOCATED,
  ROUTES.CALLS.ENG_NETWORKS_UNALLOCATED,
  ROUTES.CALLS.ENG_NETWORKS_MY_CALLS,
  ROUTES.DEFECTS.APARTMENTS,
  ROUTES.DEFECTS.ENG_NETWORKS,
  ROUTES.PLAN.ROOT,
  ROUTES.PLAN.ENGINEERINGS,
  ROUTES.ENGINEERING.ROOT,
  ROUTES.TIMESHEET.APARTMENTS,
  ROUTES.TIMESHEET.ENG_NETWORKS,
  ROUTES.DOCUMENTS.ROOT,
  // ROUTES.ANALYTICS.CONTRACTOR,
  ROUTES.ANALYTICS.TRANSFER_TO_SETTLEMENT,
];

const FURNISHING_SUPERVISOR_MENU = [ROUTES.APARTMENT_STATUS.ROOT, ROUTES.DEFECTS.APARTMENTS];

const HEAD_EN_MENU = [
  ROUTES.PLACEMENTS_STATUS.ROOT,
  ROUTES.CALLS.ENG_NETWORKS,
  ROUTES.CALLS.ENG_NETWORKS_ALLOCATED,
  ROUTES.CALLS.ENG_NETWORKS_UNALLOCATED,
  ROUTES.CALLS.ENG_NETWORKS_MY_CALLS,
  ROUTES.DEFECTS.APARTMENTS,
  ROUTES.DEFECTS.ENG_NETWORKS,
  ROUTES.PLAN.ROOT,
  ROUTES.PLAN.ENGINEERINGS,
  ROUTES.ENGINEERING.ROOT,
  ROUTES.TIMESHEET.APARTMENTS,
  ROUTES.TIMESHEET.ENG_NETWORKS,
  ROUTES.SETTING.ROOT,
  ROUTES.SETTING.ENG_NET,
  ROUTES.SETTING.ENG_NET_BY_OBJECT,
  ROUTES.SETTING.ENG_NET_BY_PROJECT,
  ROUTES.DOCUMENTS.ROOT,
  // ROUTES.ANALYTICS.CONTRACTOR,
  ROUTES.ANALYTICS.TRANSFER_TO_SETTLEMENT,
];

const HEAD_OVP_MENU = [
  ROUTES.APARTMENT_STATUS.ROOT,
  ROUTES.PLACEMENTS_STATUS.ROOT,
  ROUTES.TIMESHEET.APARTMENTS,
  ROUTES.CALLS.APARTMENTS,
  ROUTES.CALLS.APARTMENTS_ALLOCATED,
  ROUTES.DEFECTS.APARTMENTS,
  ROUTES.PLAN.ROOT,
  ROUTES.PLAN.PLACEMENTS,
  ROUTES.PLAN.ENGINEERINGS,
  ROUTES.PLAN.NEW_ENGINEERING,
  ROUTES.START_SETTLEMENT.ROOT,
  ROUTES.TIMETABLE.ROOT,
  ROUTES.TIMETABLE.APARTMENTS,
  ROUTES.TIMETABLE.APARTMENTS_MANAGERS,
  ROUTES.TIMETABLE.APARTMENTS_PROJECTS,
  ROUTES.SETTING.APARTMENTS,
  // ROUTES.ANALYTICS.CONTRACTOR,
  ROUTES.ANALYTICS.TRANSFER_TO_SETTLEMENT,
  ROUTES.ANALYTICS.RATING,
  ROUTES.ANALYTICS.REPORTING_OVP,
  ROUTES.ANALYTICS.APARTMENT_STATUS,
  ROUTES.DELIVERY_SCHEDULE.APARTMENTS,
];

const OBSERVER_MENU = [
  ROUTES.APARTMENT_STATUS.ROOT,
  ROUTES.PLACEMENTS_STATUS.ROOT,
  ROUTES.TIMESHEET.ROOT,
  ROUTES.TIMESHEET.APARTMENTS,
  ROUTES.TIMESHEET.ENG_NETWORKS,
  ROUTES.CALLS.APARTMENTS,
  ROUTES.CALLS.APARTMENTS_ALLOCATED,
  ROUTES.CALLS.APARTMENTS_UNALLOCATED,
  ROUTES.CALLS.ENG_NETWORKS,
  ROUTES.CALLS.ENG_NETWORKS_ALLOCATED,
  ROUTES.CALLS.ENG_NETWORKS_UNALLOCATED,
  ROUTES.DEFECTS.APARTMENTS,
  ROUTES.DEFECTS.ENG_NETWORKS,
  ROUTES.UPLOADING_PLAN.ROOT,
  ROUTES.UPLOADING_PLAN.APARTMENTS,
  ROUTES.PLAN.ROOT,
  ROUTES.PLAN.PLACEMENTS,
  ROUTES.PLAN.ENGINEERINGS,
  ROUTES.PLAN.NEW_ENGINEERING,
  ROUTES.START_SETTLEMENT.ROOT,
  ROUTES.ENGINEERING.ROOT,
  ROUTES.TIMETABLE.ROOT,
  ROUTES.TIMETABLE.APARTMENTS,
  ROUTES.TIMETABLE.APARTMENTS_MANAGERS,
  ROUTES.TIMETABLE.APARTMENTS_PROJECTS,
  ROUTES.SETTING.ROOT,
  ROUTES.SETTING.APARTMENTS,
  ROUTES.SETTING.ENG_NET,
  ROUTES.SETTING.ENG_NET_BY_OBJECT,
  ROUTES.SETTING.ENG_NET_BY_PROJECT,
  // ROUTES.ANALYTICS.CONTRACTOR,
  ROUTES.ANALYTICS.TRANSFER_TO_SETTLEMENT,
  ROUTES.ANALYTICS.RATING,
  ROUTES.ANALYTICS.REPORTING_OVP,
  ROUTES.ANALYTICS.APARTMENT_STATUS,
  ROUTES.DELIVERY_SCHEDULE.APARTMENTS,
];

const PARTNER_MENU = [ROUTES.APARTMENT_LIST.ROOT];

const PLANNER_MENU = [
  ROUTES.APARTMENT_STATUS.ROOT,
  ROUTES.PLAN.ROOT,
  ROUTES.PLAN.PLACEMENTS,
  ROUTES.PLAN.ENGINEERINGS,
  ROUTES.UPLOADING_PLAN.ROOT,
  ROUTES.UPLOADING_PLAN.APARTMENTS,
  ROUTES.ENGINEERING.ROOT,
  ROUTES.DELIVERY_SCHEDULE.APARTMENTS,
];

const COMMON_PRIME_CONTRACTOR_MENU = [
  ROUTES.ENGINEERING.ROOT,
  ROUTES.DELIVERY_SCHEDULE.APARTMENTS,
  ROUTES.PLAN.ROOT,
  ROUTES.PLAN.PLACEMENTS,
  ROUTES.PLAN.ENGINEERINGS,
  ROUTES.CALLS.APARTMENTS,
  ROUTES.CALLS.APARTMENTS_ALLOCATED,
  ROUTES.CALLS.APARTMENTS_UNALLOCATED,
  ROUTES.CALLS.ENG_NETWORKS,
  ROUTES.CALLS.ENG_NETWORKS_ALLOCATED,
  ROUTES.CALLS.ENG_NETWORKS_UNALLOCATED,
  ROUTES.START_SETTLEMENT.ROOT,
  // ROUTES.ANALYTICS.CONTRACTOR,
  ROUTES.ANALYTICS.TRANSFER_TO_SETTLEMENT,
  ROUTES.ANALYTICS.RATING,
];

const PRIME_CONTRACTOR_MENU = (accountingTypes: ACCOUNTING_TYPES | null) => {
  const result = [
    ...COMMON_PRIME_CONTRACTOR_MENU,
    // TODO - для разработки ФП
    '/feature-packages/apartmentsStatus',
  ];
  if (accountingTypes?.includes(IZS)) {
    result.unshift(ROUTES.PLACEMENTS_STATUS.ROOT);
  }
  if (accountingTypes?.includes(MKD)) {
    result.unshift(ROUTES.APARTMENT_STATUS.ROOT);
  }
  return result;
};

const HOUSING_CONTRACTOR_MENU = [ROUTES.PLACEMENTS_STATUS.ROOT];

const USK_PRE_ACCEPTANCE_MENU = [ROUTES.APARTMENT_STATUS.ROOT, ROUTES.DEFECTS.APARTMENTS];

const SUPERVISOR_MENU = [
  ROUTES.APARTMENT_STATUS.ROOT,
  ROUTES.PLACEMENTS_STATUS.ROOT,
  ROUTES.TIMESHEET.APARTMENTS,
  ROUTES.TIMESHEET.ENG_NETWORKS,
  ROUTES.CALLS.APARTMENTS,
  ROUTES.CALLS.APARTMENTS_ALLOCATED,
  ROUTES.CALLS.APARTMENTS_UNALLOCATED,
  ROUTES.CALLS.ENG_NETWORKS,
  ROUTES.CALLS.ENG_NETWORKS_ALLOCATED,
  ROUTES.CALLS.ENG_NETWORKS_UNALLOCATED,
  ROUTES.DEFECTS.APARTMENTS,
  ROUTES.DEFECTS.ENG_NETWORKS,
  ROUTES.UPLOADING_PLAN.ROOT,
  ROUTES.UPLOADING_PLAN.APARTMENTS,
  ROUTES.PLAN.ROOT,
  ROUTES.PLAN.PLACEMENTS,
  ROUTES.PLAN.ENGINEERINGS,
  ROUTES.START_SETTLEMENT.ROOT,
  ROUTES.ENGINEERING.ROOT,
  ROUTES.TIMETABLE.ROOT,
  ROUTES.TIMETABLE.APARTMENTS,
  ROUTES.TIMETABLE.APARTMENTS_MANAGERS,
  ROUTES.TIMETABLE.APARTMENTS_PROJECTS,
  ROUTES.SETTING.ROOT,
  ROUTES.SETTING.APARTMENTS,
  ROUTES.SETTING.ENG_NET,
  ROUTES.SETTING.ENG_NET_BY_OBJECT,
  ROUTES.SETTING.ENG_NET_BY_PROJECT,
  // ROUTES.ANALYTICS.CONTRACTOR,
  ROUTES.ANALYTICS.TRANSFER_TO_SETTLEMENT,
  ROUTES.ANALYTICS.RATING,
  ROUTES.ANALYTICS.REPORTING_OVP,
  ROUTES.ANALYTICS.APARTMENT_STATUS,
  ROUTES.DELIVERY_SCHEDULE.APARTMENTS,
];

export const ROLE_MENU_PERMISSIONS = {
  [COMMERCIAL]: COMMERCIAL_MENU,
  [ENGINEERING_NETWORKS]: ENGINEERING_NETWORKS_MENU,
  [FURNISHING_SUPERVISOR]: FURNISHING_SUPERVISOR_MENU,
  [HEAD_EN]: HEAD_EN_MENU,
  [HEAD_OVP]: HEAD_OVP_MENU,
  [OBSERVER]: OBSERVER_MENU,
  [PARTNER]: PARTNER_MENU,
  [PLANNER]: PLANNER_MENU,
  [PRIME_CONTRACTOR]: PRIME_CONTRACTOR_MENU,
  [HOUSING_CONTRACTOR]: HOUSING_CONTRACTOR_MENU,
  [USK_PRE_ACCEPTANCE]: USK_PRE_ACCEPTANCE_MENU,
  [SUPERVISOR]: SUPERVISOR_MENU,
};
